import React, { useState, useEffect } from 'react';
import { getIndianTv } from '../services/tmdbService';
import SectionHeader from './SectionHeader';
import MediaGridCard from './MediaGridCard';
import Pagination from './Pagination';
import LoadingSpinner from './LoadingSpinner';
import '../styles/main.css';

const IndianTv = () => {
  const [indianTv, setIndianTv] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIndianTv = async () => {
      setLoading(true);

      try {
        const tvShows = await getIndianTv(currentPage);

        // Urutkan dari TV Show terbaru ke yang lebih lama
        const sortedShows = (tvShows || []).sort((a, b) => {
          const dateA = new Date(
            a.first_air_date || '1900-01-01'
          );

          const dateB = new Date(
            b.first_air_date || '1900-01-01'
          );

          return dateB - dateA;
        });

        setIndianTv(sortedShows);
      } catch (error) {
        console.error('Error fetching Indian TV shows:', error);
        setIndianTv([]);
      } finally {
        setLoading(false);
      }
    };

    fetchIndianTv();
  }, [currentPage]);

  const handlePageChange = (direction) => {
    setCurrentPage((prevPage) => {
      if (direction === 'next') {
        return prevPage + 1;
      }

      if (direction === 'prev') {
        return Math.max(prevPage - 1, 1);
      }

      return prevPage;
    });
  };

  return (
    <section className="content-section" id="indiantv">
      <SectionHeader
        title="Indian TV Shows"
        icon="fi fi-in"
      />

      {loading ? (
        <LoadingSpinner label="Loading Indian TV shows" />
      ) : indianTv.length > 0 ? (
        <div className="media-grid">
          {indianTv.slice(0, 20).map((show) => (
            <MediaGridCard
              key={show.id}
              item={show}
              linkTo={`/tv/${show.id}`}
              icon="fa-star"
            />
          ))}
        </div>
      ) : (
        <div className="empty-state">
          <p>No Indian TV shows found.</p>
        </div>
      )}

      <Pagination
        currentPage={currentPage}
        onPageChange={handlePageChange}
      />
    </section>
  );
};

export default IndianTv;